var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.00021 14.6667C11.1924 14.6667 13.7802 12.0789 13.7802 8.88666C13.7802 5.69445 11.1924 3.10666 8.00021 3.10666C4.80801 3.10666 2.22021 5.69445 2.22021 8.88666C2.22021 12.0789 4.80801 14.6667 8.00021 14.6667Z",
    fill: "#282829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16668C7.72667 9.16668 7.5 8.94001 7.5 8.66668V5.33334C7.5 5.06001 7.72667 4.83334 8 4.83334C8.27333 4.83334 8.5 5.06001 8.5 5.33334V8.66668C8.5 8.94001 8.27333 9.16668 8 9.16668Z",
    fill: "#282829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92659 2.30001H6.07326C5.80659 2.30001 5.59326 2.08668 5.59326 1.82001C5.59326 1.55334 5.80659 1.33334 6.07326 1.33334H9.92659C10.1933 1.33334 10.4066 1.54668 10.4066 1.81334C10.4066 2.08001 10.1933 2.30001 9.92659 2.30001Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.f00bce5b1de11c3f0e50b913dc462fd1.svg";
export { ForwardRef as ReactComponent };